<div class="row main-box px-3 pt-3 mb-3 mx-0"
    [style.background-color]="isNotesContext ? 'white' : null">

    <div class="d-flex justify-content-between mb-3 w-100"
        [class.cursor-pointer]="!isNotesContext"
        [id]="!isNotesContext ? 'email-editor-information-filter' : null">
        <div>
            <span style="font-size:12px; font-weight:bold;">{{ title }}</span>
        </div>
    </div>

    <div [ngClass]="isNotesContext ? 'col-xs-12 mb-3 mt-1 pl-4' : 'col-xs-12 mb-3'">
        <div [ngClass]="isNotesContext ? 'row' : ''">

            <div class="col-xs-12 px-0 mb-2"
                *ngIf="candidateInformationList && candidateInformationList.length > 0">
                <div class="name">
                    <div class="checkbox-nice d-flex">
                        <input type="checkbox"
                            [id]="checkboxPrefix + '-all'"
                            [name]="checkboxPrefix + '-all'"
                            [checked]="selectAll"
                            (change)="onSelectAllChange($event)" />
                        <label [for]="checkboxPrefix + '-all'">Select All</label>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-md-4 col-lg-4 px-0 mb-2"
                *ngFor="let candidate of (candidateInformationList || []); let i = index">
                <div class="name">
                    <div class="checkbox-nice d-flex">
                        <input type="checkbox"
                            [id]="checkboxPrefix + '-' + i"
                            [name]="checkboxPrefix + '-' + i"
                            [checked]="candidate[selectedProp]"
                            (change)="onCandidateChange(candidate, $event)" />
                        <label class="oneemfontsize text-nowrap mx-2 text-overflow-ellipsis"
                            [for]="checkboxPrefix + '-' + i">
                            {{ candidate.name }}
                        </label>
                    </div>
                </div>
            </div>

            <div [ngClass]="isNotesContext ? 'col-xs-12 text-muted my-2' : 'text-muted my-2'"
                *ngIf="!candidateInformationList || candidateInformationList.length === 0">
                <span class="ml-5 my-2">No information to include.</span>
            </div>

        </div>
    </div>

</div>
